function jobcard_total_change(){
		oil 		= isNaN(x = parseInt($("#jobcard_oil").val())) 			? 	0 : x	; 
		part 		= isNaN(x = parseInt($("#jobcard_part").val())) 		? 	0 : x 	;
		labour 		= isNaN(x = parseInt($("#jobcard_labour").val())) 		? 	0 : x	;
		other 		= isNaN(x = parseInt($("#jobcard_other").val())) 		? 	0 : x	;
		discount 	= isNaN(x = parseInt($("#jobcard_discount").val())) 	? 	0 : x	;
		
		total_receivalble = oil + part + labour + other - discount;
		
		cash_payment	=	isNaN(x = parseInt($("#cash_payment_jobcard").val())) 	? 	0 : x	;
		bank_payment	=	isNaN(x = parseInt($("#bank_payment_jobcard").val())) 	? 	0 : x	;
		
		total_received	=	cash_payment + bank_payment	;
		
		total_match = total_received == total_receivalble	;
		total_colour = total_match ? "rgba(0, 255, 0, 0.5)" : "rgba(255, 0, 0, 0.3)"		;
		
		$("#jobcard_total").val(total_receivalble).change();
		$("#jobcard_total").css("background-color", total_colour);
		
}

jQuery(function(){
	$( ".jobcard_total_change" ).change(function() {
		jobcard_total_change()	;
	});
});

function calculate(){
		basic 		= isNaN(x = parseInt($("#basic_amt").val())) 	? 	0 : x					;
		discount 	= isNaN(x = parseInt($("#discount").val())) 	? 	0 : x					;
		
		discount_amt	=	basic * discount / 100	;
		net_amt			=	basic - discount_amt	;
		
		$("#net_amt").val(net_amt);
}

jQuery(function(){
	$( ".calculate" ).change(function() {
		calculate()	;
	});
});